/**
 * LA MISMA regla del servidor (docs/esquema.md §4 carro_tara y guard de
 * agregado): la tara aplicable a un viaje es la de MAYOR vigente_desde <=
 * fecha del viaje. El snapshot elegido se congela en el borrador — una
 * actualización de catálogos no cambia un viaje ya revisado.
 */

export interface TaraCatalogo {
	id: string;
	carro_id: string;
	tara_g: number;
	vigente_desde: string;
}

export function taraAplicable(taras: TaraCatalogo[], carroId: string, fecha: string): TaraCatalogo | null {
	let mejor: TaraCatalogo | null = null;
	for (const tara of taras) {
		if (tara.carro_id !== carroId || tara.vigente_desde > fecha) continue;
		if (!mejor || tara.vigente_desde > mejor.vigente_desde) mejor = tara;
	}
	return mejor;
}
